import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../../context/AppContext';
import styles from './SearchBarKeyWordInput.module.scss';

const SearchBarKeyWordInput = (props: any) => {
    const { name, updateName, updateSelectedSpecialty, updateLocation } = useContext(AppContext);
    
    useEffect(() => {
        updateSelectedSpecialty('');
        updateLocation('')
    }, [])

  return (
    <div className={styles.locationInputContainer}>
      <input
        className={styles.locationInput}
        type="text"
        placeholder="Doctor name, practice, facility, or pharmacy"
        value={name === 'undefined' ? '' : name}
        onChange={(e) => updateName(e.target.value)}
      />
    </div>
  );
};

export default SearchBarKeyWordInput;
